// @ts-nocheck
import { post } from './utils/api/index';
const API_SYNC_URL = process.env.REACT_APP_BASE_API_URL_SYNC || 'http://localhost:32768';
const DISPONIBILIDADE_FROTA_PATIO_ENDPOINT = process.env.REACT_APP_DISPONIBILIDADE_FROTA_PATIO_ENDPOINT || '/api/v1/Disponibilidade/BuscarDisponibilidade';
const DISPONIBILIDADE_FROTA_PATIO_URL = new URL(DISPONIBILIDADE_FROTA_PATIO_ENDPOINT, API_SYNC_URL).toString();
const emptyDisponibilidade = {
    veiculos: [],
    motoristas: []
};
export const getDisponibilidadeFrotaPatio = async (payload = {}) => {
    try {
        const response = await post(DISPONIBILIDADE_FROTA_PATIO_URL, payload);
        return response?.data || response || emptyDisponibilidade;
    }
    catch (error) {
        console.error('Erro ao buscar disponibilidade frota patio:', error);
        throw error;
    }
};
